module.exports = __webpack_public_path__ + "img/logo_gisele.9cafe342.png";